<div class="ethel-root">
  <app-ethel-bubble #bubble />
  @defer (on interaction(bubble); when store.open()) {
    @if (store.open()) {
      <app-ethel-drawer />
    }
  } @loading {
    @if (store.open()) {
      <div class="eh-loading" role="status" [attr.aria-label]="'ethel.header.title' | transloco"></div>
    }
  }
</div>
